<template>
  <Layout :linksData="linksData">
    <v-row class="leads-managements w-100">
      <v-col cols="12" :lg="6" class="header-line-title">
        <div class="leads-managements-link d-flex align-center ga-2 my-3">
          <div
            @click="$router.push({ name: 'Projectsmanagement' })"
            class="link cursor-pointer hoverd-style-line d-flex align-center ga-2"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z"
                fill="#1F666A"
              />
            </svg>
            <span>Projects</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <div class="project-card">
          <div class="element">
            <div class="title">Projects</div>
            <div class="d-flex flex-column ga-3 align-center justify-center">
              <div class="icon vauy">
                <svg
                  width="20"
                  height="14"
                  viewBox="0 0 20 14"
                  fill="#ddd"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.1014 11.8618H10.8246C10.5862 11.8618 10.3576 11.9526 10.1891 12.1143C10.0205 12.276 9.92578 12.4953 9.92578 12.7239C9.92578 12.9525 10.0205 13.1718 10.1891 13.3335C10.3576 13.4951 10.5862 13.586 10.8246 13.586H19.1014C19.3398 13.586 19.5684 13.4951 19.7369 13.3335C19.9055 13.1718 20.0002 12.9525 20.0002 12.7239C20.0002 12.4953 19.9055 12.276 19.7369 12.1143C19.5684 11.9526 19.3398 11.8618 19.1014 11.8618Z"
                    fill="#4D4D4D"
                  />
                  <path
                    d="M15.031 6.1377H6.75433C6.51594 6.1377 6.28731 6.22852 6.11874 6.39019C5.95017 6.55186 5.85547 6.77113 5.85547 6.99976C5.85547 7.2284 5.95017 7.44767 6.11874 7.60934C6.28731 7.77101 6.51594 7.86183 6.75433 7.86183H15.031C15.2694 7.86183 15.4981 7.77101 15.6666 7.60934C15.8352 7.44767 15.9299 7.2284 15.9299 6.99976C15.9299 6.77113 15.8352 6.55186 15.6666 6.39019C15.4981 6.22852 15.2694 6.1377 15.031 6.1377Z"
                    fill="#4D4D4D"
                  />
                  <path
                    d="M9.17558 0.413574H0.898862C0.660469 0.413574 0.431841 0.504398 0.263271 0.666068C0.0947022 0.827737 0 1.04701 0 1.27564C0 1.50428 0.0947022 1.72355 0.263271 1.88522C0.431841 2.04689 0.660469 2.13771 0.898862 2.13771H9.17558C9.41397 2.13771 9.6426 2.04689 9.81117 1.88522C9.97974 1.72355 10.0744 1.50428 10.0744 1.27564C10.0744 1.04701 9.97974 0.827737 9.81117 0.666068C9.6426 0.504398 9.41397 0.413574 9.17558 0.413574Z"
                    fill="#4D4D4D"
                  />
                </svg>
              </div>
              <div class="number">{{ project_data.total }}</div>
              <div class="title">Total Projects</div>
              <div class="disc d-flex align-center ga-3">
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_2389_55531)">
                    <path
                      d="M10.4999 20C16.0228 20 20.4999 15.5229 20.4999 10C20.4999 4.47716 16.0228 0 10.4999 0C4.97713 0 0.5 4.47716 0.5 10C0.5 15.5229 4.97713 20 10.4999 20Z"
                      fill="#F2F2F2"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M20.1593 8.37904C20.4073 8.22681 20.5382 7.93937 20.4902 7.65239L19.5482 2.02494C19.5166 1.83593 19.4103 1.66756 19.2533 1.55766C19.0963 1.44777 18.9018 1.40559 18.7133 1.44059L13.3713 2.43286C13.0915 2.48481 12.8693 2.69783 12.8056 2.97511C12.7419 3.2524 12.8488 3.54107 13.0777 3.70996L15.4375 5.4506L11.372 11.2562L7.65986 8.65373C7.46589 8.51776 7.22585 8.46443 6.99255 8.50549C6.75927 8.54656 6.55185 8.67864 6.41597 8.87267L0.661571 17.09C0.378717 17.494 0.476858 18.0507 0.880775 18.3336C1.28469 18.6164 1.84143 18.5183 2.12429 18.1143L7.36628 10.6287L11.0784 13.2312C11.2724 13.3671 11.5125 13.4205 11.7458 13.3794C11.979 13.3383 12.1865 13.2062 12.3223 13.0122L16.8751 6.51091L19.3616 8.34513C19.5959 8.51786 19.9113 8.53127 20.1593 8.37904Z"
                      fill="#45C948"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2389_55531">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <div class="percentage">5.2%</div>
                <div class="text">Project Growth this year</div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="project-card">
          <div class="element">
            <div class="title">Total Projects Values</div>
            <div class="d-flex flex-column ga-3 align-center justify-center">
              <div class="icon vauy">
                <svg
                  width="20"
                  height="14"
                  viewBox="0 0 20 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.1014 11.8618H10.8246C10.5862 11.8618 10.3576 11.9526 10.1891 12.1143C10.0205 12.276 9.92578 12.4953 9.92578 12.7239C9.92578 12.9525 10.0205 13.1718 10.1891 13.3335C10.3576 13.4951 10.5862 13.586 10.8246 13.586H19.1014C19.3398 13.586 19.5684 13.4951 19.7369 13.3335C19.9055 13.1718 20.0002 12.9525 20.0002 12.7239C20.0002 12.4953 19.9055 12.276 19.7369 12.1143C19.5684 11.9526 19.3398 11.8618 19.1014 11.8618Z"
                    fill="#4D4D4D"
                  />
                  <path
                    d="M15.031 6.1377H6.75433C6.51594 6.1377 6.28731 6.22852 6.11874 6.39019C5.95017 6.55186 5.85547 6.77113 5.85547 6.99976C5.85547 7.2284 5.95017 7.44767 6.11874 7.60934C6.28731 7.77101 6.51594 7.86183 6.75433 7.86183H15.031C15.2694 7.86183 15.4981 7.77101 15.6666 7.60934C15.8352 7.44767 15.9299 7.2284 15.9299 6.99976C15.9299 6.77113 15.8352 6.55186 15.6666 6.39019C15.4981 6.22852 15.2694 6.1377 15.031 6.1377Z"
                    fill="#4D4D4D"
                  />
                  <path
                    d="M9.17558 0.413574H0.898862C0.660469 0.413574 0.431841 0.504398 0.263271 0.666068C0.0947022 0.827737 0 1.04701 0 1.27564C0 1.50428 0.0947022 1.72355 0.263271 1.88522C0.431841 2.04689 0.660469 2.13771 0.898862 2.13771H9.17558C9.41397 2.13771 9.6426 2.04689 9.81117 1.88522C9.97974 1.72355 10.0744 1.50428 10.0744 1.27564C10.0744 1.04701 9.97974 0.827737 9.81117 0.666068C9.6426 0.504398 9.41397 0.413574 9.17558 0.413574Z"
                    fill="#4D4D4D"
                  />
                </svg>
              </div>
              <div class="number">{{ project_Values_data.total }}</div>
              <div class="title">Projects Values</div>
              <div class="disc d-flex align-center ga-3">
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_2389_55531)">
                    <path
                      d="M10.4999 20C16.0228 20 20.4999 15.5229 20.4999 10C20.4999 4.47716 16.0228 0 10.4999 0C4.97713 0 0.5 4.47716 0.5 10C0.5 15.5229 4.97713 20 10.4999 20Z"
                      fill="#F2F2F2"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M20.1593 8.37904C20.4073 8.22681 20.5382 7.93937 20.4902 7.65239L19.5482 2.02494C19.5166 1.83593 19.4103 1.66756 19.2533 1.55766C19.0963 1.44777 18.9018 1.40559 18.7133 1.44059L13.3713 2.43286C13.0915 2.48481 12.8693 2.69783 12.8056 2.97511C12.7419 3.2524 12.8488 3.54107 13.0777 3.70996L15.4375 5.4506L11.372 11.2562L7.65986 8.65373C7.46589 8.51776 7.22585 8.46443 6.99255 8.50549C6.75927 8.54656 6.55185 8.67864 6.41597 8.87267L0.661571 17.09C0.378717 17.494 0.476858 18.0507 0.880775 18.3336C1.28469 18.6164 1.84143 18.5183 2.12429 18.1143L7.36628 10.6287L11.0784 13.2312C11.2724 13.3671 11.5125 13.4205 11.7458 13.3794C11.979 13.3383 12.1865 13.2062 12.3223 13.0122L16.8751 6.51091L19.3616 8.34513C19.5959 8.51786 19.9113 8.53127 20.1593 8.37904Z"
                      fill="#45C948"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2389_55531">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <div class="percentage">5.2%</div>
                <div class="text">Project Growth this year</div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8">
        <div class="pa-4 project-card" elevation="2">
          <div class="d-flex justify-space-start element">
            <div class="title">Projects Status</div>
          </div>
          <div class="">
            <canvas ref="chartCanvas"></canvas>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8">
        <div class="pa-4 project-card" elevation="2">
          <div class="d-flex justify-space-start element">
            <div class="title">Projects</div>
          </div>
          <div class="">
            <div
              v-for="(item, index) in platforms_data"
              :key="index"
              class="d-flex justify-space-between align-center py-3"
            >
              <div class="logo-name d-flex align-center ga-3">
                <span>{{ item.title }}</span>
              </div>
              <div
                class="number-chart-percent d-flex align-center justify-end ga-2 w-50"
              >
                <div class="chart">
                  <span
                    class="background"
                    :style="{ width: item.percent + '%' }"
                  ></span>
                </div>
                <div class="percent">{{ item.percent }}</div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </Layout>
</template>
<script>
import Layout from "@/components/crm/layouts/Layout.vue";
import "@/assets/css/crm/crm-moduls.css";
import { Chart, registerables } from "chart.js";
import apiClient from "@/core/buildRequest";

Chart.register(...registerables);

export default {
  components: {
    Layout,
  },

  data() {
    return {
      selected_projects: [],
      linksData: [
        { name: "Home", link: "/home-page" },
        { name: "Projects Management", link: "" },
      ],
      store: null,

      chart: null,
      chartData: {
        labels: ["Active", "Pending", "on_hold", "Completed", "Closed"],
        datasets: [
          {
            label: "Project Status",
            data: [0, 0, 0, 0, 0],
            backgroundColor: [
              "#78B5ED",
              "#E6E6E6",
              "#EDBC78",
              "#89FBB2",
              "#FB8989",
            ],
            borderColor: [
              "#78B5ED",
              "#E6E6E6",
              "#EDBC78",
              "#89FBB2",
              "#FB8989",
            ],
            borderWidth: 1,
            borderRadius: 8,
            maxBarThickness: 28,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            display: true,
          },
        },
        scales: {
          x: {
            beginAtZero: true,
          },
          y: {
            beginAtZero: true,
          },
        },
      },
      platforms_data: [
        {
          title: "DIGITAL MARKETING",
          percent: "45%",
        },
        {
          title: "SOFTWARE DEVELOPMENT",
          percent: "45%",
        },
        {
          title: "EVENT PLANNING",
          percent: "10%",
        },
        {
          title: "MERCHANDISE",
          percent: "5%",
        },
      ],
      project_data: {
        total: 0,
        percent: "45%",
        growth_rate: "Negative",
      },
      project_Values_data: {
        total: 0,
        percent: "45%",
        growth_rate: "Negative",
      },
    };
  },
  computed: {},
  methods: {
    async getData() {
      try {
        const res = await apiClient.get(
          "/leads-managment/projects/get/insights"
        );
        console.log(res);
        this.chartData.labels = res.data.data.status.map((item) => {
          return item.status;
        });
        this.chartData.datasets[0].data = res.data.data.status.map((item) => {
          return item.percentage;
        });
        const ctx = this.$refs.chartCanvas.getContext("2d");
        this.chart = new Chart(ctx, {
          type: "bar",
          data: this.chartData,
          options: this.chartOptions,
        });
        this.project_data.total = res.data.data.total_projects;
        // this.project_data.percent = res.data.data.projects_percent;
        // this.project_data.growth_rate = res.data.data.projects_growth_rate;

        this.project_Values_data.total = res.data.data.total_values;
        // this.project_Values_data.percent = res.data.data.project_values_percent;
        // this.project_Values_data.growth_rate =
        //   res.data.data.project_values_growth_rate;
        this.platforms_data = res.data.data.type.map((item) => {
          return {
            title: item.type,
            percent: item.percentage,
          };
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
.project-card {
  padding: 24px;
  background: #ffffff;
  box-shadow: 0px 10px 60px 0px #dedede80;
}
.project-card .data .element {
  height: 40px;
  padding: 0px 24px 0px 16px;
  background: #f7f8f8;
  border-radius: 8px;
}
.project-card .element .title {
  font-size: 14px;
  font-weight: bolder;
  line-height: 16.94px;
  color: #0d0d0d;
}

.project-card .number {
  font-size: 16px;
  font-weight: 700;
  line-height: 19.36px;
  color: #1a1a1a;
}

.project-card .disc {
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  color: #666666;
}

.project-card .percentage {
  font-size: 16px;
  font-weight: 700;
  line-height: 19.36px;
  color: #1f0609;
}

.project-card .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.touched-untouched-labels {
  font-size: 14px;
  color: #666666;
}
.number-chart-percent .chart {
  position: relative;
  border-radius: 15px;
  background-color: rgba(240, 240, 240, 0.342);
  width: 85%;
  height: 8px;
}
.number-chart-percent .chart .background {
  background: linear-gradient(90deg, #1f666a 0%, #3f878d 42%, #4f979f 100%);
  border-radius: 15px;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 0px;
  transition: all 0.5s ease-in-out;
}
</style>
<style scoped>
.vauy {
  width: 4rem;
  height: 4rem;
  background-color: #f1f7f8;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
